<!-- Header de página -->
<div class="page-header">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h1 class="page-title">ÓRDENES DE TRANSPORTE AGENCIA</h1>
      <p class="page-subtitle text-muted">
        Gestión y consulta de órdenes de transporte para liquidaciones de agencia
      </p>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" (click)="exportarExcel()"
        [disabled]="isLoading || isGeneratingExcel || totalRegistros === 0"
        [matTooltip]="isGeneratingExcel ? 'Generando Excel...' : (totalRegistros === 0 ? 'No hay datos para exportar' : 'Exportar registros del filtro actual a Excel (sin paginación)')">
        <mat-icon>download</mat-icon>
        Excel
      </button>
      <button mat-raised-button color="accent" (click)="exportarExcelConsolidado()"
        [disabled]="isLoading || isGeneratingExcelConsolidado || totalRegistros === 0"
        [matTooltip]="isGeneratingExcelConsolidado ? 'Generando Excel Consolidado...' : (totalRegistros === 0 ? 'No hay datos para exportar' : 'Exportar una fila por contenedor con toda la trazabilidad')">
        <mat-icon>table_view</mat-icon>
        Excel Consolidado
      </button>
    </div>
  </div>
</div>

<!-- Filtros de búsqueda -->
<mat-card class="filters-card">
  <mat-card-header>
    <mat-card-title>
      <mat-icon>filter_list</mat-icon>
      Filtros de Búsqueda
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="filters-section">
      <div class="filters-grid filters-grid-50">
        <!-- Primera fila: Cliente, Proveedor, Nave, Temporada -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Cliente</mat-label>
          <input matInput [formControl]="filtroCliente" [matAutocomplete]="autoCliente"
            [readonly]="filtroCliente.disabled" placeholder="Buscar cliente" inputmode="search">
          <mat-autocomplete #autoCliente="matAutocomplete" [displayWith]="displayCliente">
            <mat-option [value]="''">Todos los clientes</mat-option>
            <mat-option *ngFor="let cliente of filteredClientesOptions" [value]="cliente.clienteId">
              {{cliente.cliente}}
            </mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>business</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Exportador</mat-label>
          <input matInput [formControl]="filtroExportador" [matAutocomplete]="autoExportador"
            placeholder="Buscar exportador" inputmode="search">
          <mat-autocomplete #autoExportador="matAutocomplete" [displayWith]="displayExportador">
            <mat-option [value]="''">Todos los exportadores</mat-option>
            <mat-option *ngFor="let exportador of filteredExportadoresOptions" [value]="exportador.exportadorId">
              {{exportador.exportador}}
            </mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>local_shipping</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Nave</mat-label>
          <input matInput [formControl]="filtroNave" [matAutocomplete]="autoNave" placeholder="Buscar nave"
            inputmode="search">
          <mat-autocomplete #autoNave="matAutocomplete" [displayWith]="displayNave">
            <mat-option [value]="''">Todas las naves</mat-option>
            <mat-option *ngFor="let nave of filteredNavesOptions" [value]="nave.vesselId">
              {{nave.vesselName}}
            </mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>directions_boat</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Temporada</mat-label>
          <mat-select [formControl]="filtroTemporada">
            <mat-option [value]="null">Todas las temporadas</mat-option>
            <mat-option *ngFor="let temporada of temporadasOptions" [value]="temporada.value">
              {{temporada.label}}
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>calendar_today</mat-icon>
        </mat-form-field>

        <!-- Segunda fila: Inicio, Fin, Ref. Cliente, Contenedor -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Inicio</mat-label>
          <input matInput [matDatepicker]="pickerInicio" [formControl]="filtroInicio" placeholder="Seleccionar fecha"
            inputmode="none">
          <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
          <mat-datepicker #pickerInicio></mat-datepicker>
          <mat-hint *ngIf="datesLockedBySearch">No disponible con Contenedor/DUS/Liquidación/Booking/Patente</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Fin</mat-label>
          <input matInput [matDatepicker]="pickerFin" [formControl]="filtroFin" placeholder="Seleccionar fecha"
            inputmode="none">
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin></mat-datepicker>
          <mat-hint *ngIf="datesLockedBySearch">No disponible con Contenedor/DUS/Liquidación/Booking/Patente</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Ref. Cliente</mat-label>
          <input matInput [formControl]="filtroRefCliente" placeholder="Referencia del cliente" inputmode="text">
          <mat-icon matSuffix>assignment</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Contenedor</mat-label>
          <input matInput [formControl]="filtroContenedor" placeholder="Número de contenedor" inputmode="text">
          <mat-icon matSuffix>inventory_2</mat-icon>
        </mat-form-field>

        <!-- Tercera fila: DUS, Nro Liquidación, Booking -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>DUS</mat-label>
          <input matInput [formControl]="filtroDus" placeholder="Número DUS" inputmode="text">
          <mat-icon matSuffix>description</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Nro Liquidación</mat-label>
          <input matInput [formControl]="filtroNroLiquidacion" placeholder="Número de liquidación" inputmode="numeric">
          <mat-icon matSuffix>receipt_long</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Booking</mat-label>
          <input matInput [formControl]="filtroBooking" placeholder="Número de booking" inputmode="text">
          <mat-icon matSuffix>confirmation_number</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Patente</mat-label>
          <input matInput [formControl]="filtroPatente" placeholder="Patente del camión" inputmode="text">
          <mat-icon matSuffix>local_shipping</mat-icon>
        </mat-form-field>
      </div>

      <!-- Botones de acción -->
      <div class="filter-actions">
        <button mat-raised-button color="primary" (click)="aplicarFiltros()" [disabled]="isLoading"
          matTooltip="Buscar con los filtros aplicados">
          <mat-icon>search</mat-icon>
          Buscar
        </button>
        <button mat-raised-button color="warn" (click)="limpiarFiltros()" [disabled]="!hasActiveFilters() || isLoading"
          matTooltip="Limpiar todos los filtros">
          <mat-icon>clear</mat-icon>
          Limpiar
        </button>
      </div>

      <!-- Indicador de filtros activos -->
      <div class="filter-chips" *ngIf="hasActiveFilters()">
        <mat-chip-set>
          <mat-chip *ngIf="filtroRefCliente.value" removable (removed)="filtroRefCliente.setValue('')">
            Ref. Cliente: {{filtroRefCliente.value}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <mat-chip *ngIf="filtroContenedor.value" removable (removed)="filtroContenedor.setValue('')">
            Contenedor: {{filtroContenedor.value}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <mat-chip *ngIf="filtroBooking.value" removable (removed)="filtroBooking.setValue('')">
            Booking: {{filtroBooking.value}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <mat-chip *ngIf="filtroNroLiquidacion.value" removable (removed)="filtroNroLiquidacion.setValue('')">
            Liquidación: {{filtroNroLiquidacion.value}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <mat-chip *ngIf="filtroPatente.value" removable (removed)="filtroPatente.setValue('')">
            Patente: {{filtroPatente.value}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-set>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<!-- Tabla de datos -->
<mat-card class="data-card">
  <mat-card-content>
    <!-- Estado de carga -->
    <div class="loading-container" *ngIf="isLoading">
      <div class="loading-spinner">
        <i class="ri-loader-4-line"></i>
        <p>Cargando órdenes de transporte...</p>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="hasError && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <h3>Error al cargar datos</h3>
      <p>{{errorMessage}}</p>
      <button mat-raised-button color="primary" (click)="buscarOrdenes()">
        <mat-icon>refresh</mat-icon>
        Reintentar
      </button>
    </div>

    <div class="liquidaciones-list-table" *ngIf="!isLoading && !hasError">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>

          <!-- Columna Nro O/T -->
          <ng-container matColumnDef="nroOt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="nroOt">Nro O/T</th>
            <td mat-cell *matCellDef="let orden">
              <strong class="os-number">{{orden.nroOt}}</strong>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              <strong>TOTALES</strong>
            </td>
          </ng-container>

          <!-- Columna Nro Liquidación -->
          <ng-container matColumnDef="nroLiquidacion">
            <th mat-header-cell *matHeaderCellDef>Nro Liquidación</th>
            <td mat-cell *matCellDef="let orden">
              <span class="liquidacion-number">{{orden.numeroLiquidacion}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              {{totales.count}} registros
            </td>
          </ng-container>

          <!-- Columna Tipo Embarque -->
          <ng-container matColumnDef="tipoEmbarque">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="tipoEmbarque">Tipo Embarque</th>
            <td mat-cell *matCellDef="let orden">
              <span class="shipment-type">{{orden.tipoEmbarque || 'N/A'}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna Cliente -->
          <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="cliente">Cliente</th>
            <td mat-cell *matCellDef="let orden">
              <span class="customer-name">{{orden.cliente}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna Exportador -->
          <ng-container matColumnDef="exportador">
            <th mat-header-cell *matHeaderCellDef>Exportador</th>
            <td mat-cell *matCellDef="let orden">
              <span class="exporter-name">{{orden.exportador || 'N/A'}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna Servicio -->
          <ng-container matColumnDef="servicio">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="servicio">Servicio</th>
            <td mat-cell *matCellDef="let orden">
              <span class="service-name">{{orden.servicio || 'N/A'}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna Nave -->
          <ng-container matColumnDef="nave">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="nave">Nave</th>
            <td mat-cell *matCellDef="let orden">
              <span class="vessel-name">{{orden.nave || 'N/A'}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna ETD -->
          <ng-container matColumnDef="etd">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="etd">ETD</th>
            <td mat-cell *matCellDef="let orden">
              <span class="date-cell">{{orden.etd}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna Ref. Cliente -->
          <ng-container matColumnDef="refCliente">
            <th mat-header-cell *matHeaderCellDef>Ref.Cliente</th>
            <td mat-cell *matCellDef="let orden">
              <span class="customer-ref">{{orden.refCliente || 'N/A'}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Columna Booking -->
          <ng-container matColumnDef="booking">
            <th mat-header-cell *matHeaderCellDef>Booking</th>
            <td mat-cell *matCellDef="let orden">
              <span class="booking-number">{{orden.booking || 'N/A'}}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <ng-container matColumnDef="montoNeto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="montoNeto" class="text-end">Monto Neto</th>
            <td mat-cell *matCellDef="let orden" class="amount-cell text-end">
              <span class="amount-value">{{ removeClpSuffix(orden.montoNeto) }}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell amount-cell text-end">
              <ng-container *ngIf="totales.totalesPorMoneda.length <= 1; else multiMonedaNeto">
                <strong class="total-amount">{{ removeClpSuffix(totales.totalMontoNeto) }}</strong>
              </ng-container>
              <ng-template #multiMonedaNeto>
                <div *ngFor="let total of totales.totalesPorMoneda" class="total-line">
                  <strong class="total-amount">{{ removeClpSuffix(total.totalMontoNeto) }}</strong>
                </div>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="extraCostos">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="extraCostos" class="text-end">Extra Costos</th>
            <td mat-cell *matCellDef="let orden" class="amount-cell text-end">
              <span class="amount-value">{{ removeClpSuffix(orden.extraCostos) }}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell amount-cell text-end">
              <ng-container *ngIf="totales.totalesPorMoneda.length <= 1; else multiMonedaExtra">
                <strong class="total-amount">{{ removeClpSuffix(totales.totalExtraCostos) }}</strong>
              </ng-container>
              <ng-template #multiMonedaExtra>
                <div *ngFor="let total of totales.totalesPorMoneda" class="total-line">
                  <strong class="total-amount">{{ removeClpSuffix(total.totalExtraCostos) }}</strong>
                </div>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="subTotal">
            <th mat-header-cell *matHeaderCellDef class="text-end">SubTotal</th>
            <td mat-cell *matCellDef="let orden" class="amount-cell text-end">
              <span class="amount-value">{{ removeClpSuffix(orden.subTotal) }}</span>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell amount-cell text-end">
              <ng-container *ngIf="totales.totalesPorMoneda.length <= 1; else multiMonedaSubTotal">
                <strong class="total-amount">{{ removeClpSuffix(totales.totalSubTotal) }}</strong>
              </ng-container>
              <ng-template #multiMonedaSubTotal>
                <div *ngFor="let total of totales.totalesPorMoneda" class="total-line">
                  <strong class="total-amount">{{ removeClpSuffix(total.totalSubTotal) }}</strong>
                </div>
              </ng-template>
            </td>
          </ng-container>

          <!-- Columna Acciones -->
          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
            <td mat-cell *matCellDef="let orden">
              <div class="action-buttons">
                <button mat-button color="primary" (click)="verOrden(orden, $event)" matTooltip="Ver vista rápida"
                  class="action-btn view-btn">
                  VER
                </button>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef class="totales-cell">
              —
            </td>
          </ng-container>

          <!-- Fila expandida -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let orden" class="expanded-detail-cell" [attr.colspan]="displayedColumns.length">
              <div *ngIf="isRowExpanded(orden)" class="expanded-detail-wrapper">
                <div class="expanded-detail-header">
                  <mat-icon>inventory</mat-icon>
                  <div class="expanded-detail-header-text">
                    <strong>Detalle de orden de transporte</strong>
                    <span>
                      Nro O/T: {{orden.nroOt}}
                    </span>
                  </div>
                </div>

                <div *ngIf="getOrderState(orden)?.isLoading" class="expanded-detail-loading">
                  <mat-spinner diameter="32"></mat-spinner>
                  <span>Cargando detalle de la orden...</span>
                </div>

                <div *ngIf="getOrderState(orden)?.error as error" class="expanded-detail-error">
                  <mat-icon color="warn">error</mat-icon>
                  <span>{{error}}</span>
                </div>

                <ng-container *ngIf="getOrderState(orden)?.data as detalle">
                  <table class="detalle-os-table">
                    <thead>
                      <tr>
                        <th>Ref. cliente</th>
                        <th>Viaje</th>
                        <th>POL</th>
                        <th>ETD</th>
                        <th>POD</th>
                        <th>Servicio</th>
                        <th>Tipo facturación</th>
                        <th>Venta Neto</th>
                        <th>Traspaso Bruto</th>
                        <th>Proveedor</th>
                        <th>Factura</th>
                        <th>CNTRS</th>
                        <th>Comentarios cliente</th>
                        <th>Fecha de liquidación</th>
                        <th>Liquidación</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{detalle.clientReference || 'N/D'}}</td>
                        <td>{{detalle.voyage || 'N/D'}}</td>
                        <td>{{detalle.pol || 'N/D'}}</td>
                        <td>{{formatDetailDate(detalle.etd)}}</td>
                        <td>{{detalle.pod || 'N/D'}}</td>
                        <td>{{detalle.serviceName || 'N/D'}}</td>
                        <td>{{detalle.billingType || 'N/D'}}</td>
                        <td class="amount-cell">{{formatMonto(detalle.netSale)}}</td>
                        <td class="amount-cell">{{formatMonto(detalle.grossTransfer)}}</td>
                        <td>{{detalle.providerName || 'N/D'}}</td>
                        <td>{{detalle.invoiceNumber || 'N/D'}}</td>
                        <td>{{detalle.containerNumber || 'N/D'}}</td>
                        <td class="comentarios-cell">{{detalle.clientComments || 'Sin comentarios'}}</td>
                        <td>{{formatDetailDate(detalle.liquidationDate)}}</td>
                        <td>{{detalle.liquidationNumber || 'N/D'}}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="7" class="totales-label">Totales</td>
                        <td class="amount-cell">{{formatMonto(detalle.netSale)}}</td>
                        <td class="amount-cell">{{formatMonto(detalle.grossTransfer)}}</td>
                        <td colspan="6"></td>
                      </tr>
                    </tfoot>
                  </table>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <!-- Filas de la tabla -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="data-row"
            [class.expanded]="isRowExpanded(row)"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns" class="totales-row"></tr>

        </table>
      </div>

      <!-- Sin datos -->
      <div *ngIf="dataSource.data.length === 0" class="no-data">
        <i class="ri-search-line"></i>
        <h3>No hay órdenes de transporte</h3>
        <p>No se encontraron órdenes que coincidan con los filtros aplicados.</p>
        <button mat-raised-button color="primary" (click)="limpiarFiltros()">
          <mat-icon>clear</mat-icon>
          Limpiar filtros
        </button>
      </div>
    </div>

    <mat-paginator *ngIf="totalRegistros > 0" #paginator [length]="totalRegistros" [pageSize]="elementosPorPagina"
      [pageSizeOptions]="[10, 25, 50, 100]" [pageIndex]="paginaActual - 1" [showFirstLastButtons]="true"
      [hidePageSize]="false" [disabled]="isLoading" (page)="onPageChange($event)" aria-label="Seleccionar página">
    </mat-paginator>
  </mat-card-content>
</mat-card>

<!-- Overlay de carga para generación de Excel -->
<div *ngIf="isGeneratingExcel" class="excel-loading-overlay">
  <div class="excel-loading-content">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="excel-loading-text">Generando Archivo Excel...</p>
  </div>
</div>

<!-- Overlay de carga para generación de Excel Consolidado -->
<div *ngIf="isGeneratingExcelConsolidado" class="excel-loading-overlay">
  <div class="excel-loading-content">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="excel-loading-text">Generando Excel Consolidado...</p>
  </div>
</div>